import React, { useEffect } from "react";
import {
  ServesBg,
  ServiceContainer,
  ServiceContent,
  ServiceTitle,
  ServiceIcon,
  BorderBg,
} from "./style";
import { FaLaptopCode } from "react-icons/fa";
import { VscCode, VscTools } from "react-icons/vsc";
import { BsPhone } from "react-icons/bs";
import { DiGoogleAnalytics } from "react-icons/di";
// import { MdDevicesOther } from "react-icons/md";
import { IoIosCloudDone } from "react-icons/io";
import AOS from "aos";
import "aos/dist/aos.css";
const Services = () => {
  useEffect(() => {
    AOS.init({
      duration: 600,
    });
    AOS.refresh();
  }, []);
  return (
    <ServiceContainer>
      {/* <ServiceTitte>{`Services I Provide`}</ServiceTitte> */}
      <BorderBg
        data-aos="zoom-in"
        data-aos-offset="100"
        data-aos-delay="20"
        data-aos-easing="ease-in-out"
        data-aos-mirror="true"
        data-aos-once="false"
        data-aos-anchor-placement="top-bottom">
        <ServesBg>
          <ServiceContent
            data-aos="zoom-in"
            data-aos-offset="100"
            data-aos-delay="20"
            data-aos-easing="ease-in-out"
            data-aos-mirror="true"
            data-aos-once="false"
            data-aos-anchor-placement="top-bottom">
            <ServiceIcon>
              <FaLaptopCode />
            </ServiceIcon>
            <ServiceTitle>{`Frontend`}</ServiceTitle>
          </ServiceContent>
          <ServiceContent
            data-aos="zoom-in"
            data-aos-offset="100"
            data-aos-delay="20"
            data-aos-easing="ease-in-out"
            data-aos-mirror="true"
            data-aos-once="false"
            data-aos-anchor-placement="top-bottom">
            <ServiceIcon>
              <VscCode />
            </ServiceIcon>
            <ServiceTitle>{`Backend`}</ServiceTitle>
          </ServiceContent>
          <ServiceContent
            data-aos="zoom-in"
            data-aos-offset="100"
            data-aos-delay="20"
            data-aos-easing="ease-in-out"
            data-aos-mirror="true"
            data-aos-once="false"
            data-aos-anchor-placement="top-bottom">
            <ServiceIcon>
              <BsPhone />
            </ServiceIcon>
            <ServiceTitle>{`Mobile`}</ServiceTitle>
          </ServiceContent>
          <ServiceContent
            data-aos="zoom-in"
            data-aos-offset="100"
            data-aos-delay="20"
            data-aos-easing="ease-in-out"
            data-aos-mirror="true"
            data-aos-once="false"
            data-aos-anchor-placement="top-bottom">
            <ServiceIcon>
              <VscTools />
            </ServiceIcon>
            <ServiceTitle>{`Maintanace`}</ServiceTitle>
          </ServiceContent>
          <ServiceContent
            data-aos="zoom-in"
            data-aos-offset="100"
            data-aos-delay="20"
            data-aos-easing="ease-in-out"
            data-aos-mirror="true"
            data-aos-once="false"
            data-aos-anchor-placement="top-bottom">
            <ServiceIcon>
              <DiGoogleAnalytics />
            </ServiceIcon>
            <ServiceTitle>{`Data Analytics`}</ServiceTitle>
          </ServiceContent>
          <ServiceContent
            data-aos="zoom-in"
            data-aos-offset="100"
            data-aos-delay="20"
            data-aos-easing="ease-in-out"
            data-aos-mirror="true"
            data-aos-once="false"
            data-aos-anchor-placement="top-bottom">
            <ServiceIcon>
              <IoIosCloudDone />
            </ServiceIcon>
            <ServiceTitle>{`Cloud`}</ServiceTitle>
          </ServiceContent>
        </ServesBg>
      </BorderBg>
    </ServiceContainer>
  );
};

export default Services;
